import { getStateCode } from '@/shared/lib/get-state-code';

import type { PracticeLocation } from '../model/practice.types';

type AddressLineLocation = Pick<PracticeLocation, 'street1' | 'street2' | 'city' | 'state' | 'zip'>;

/** `123 Main St, Suite 210, Normal, IL 11106` — `street2` is omitted when `null`. `state` is
 * stored as a full name; this displays the two-letter code instead. */
export function formatAddressLine(location: AddressLineLocation): string {
    const street = location.street2 ? `${location.street1}, ${location.street2}` : location.street1;
    return `${street}, ${location.city}, ${getStateCode(location.state)} ${location.zip}`;
}
